export default __webpack_public_path__ + "static/media/cy.77ed2b38.svg";